<main>
  <div class="home ver2">
    <tm-ng-odometer [number]="1000"
                    [observable]="observable"
                    [config]="{ animation: 'count', format: 'd', theme: 'car', value: 50, auto: false }">
    </tm-ng-odometer>
  </div>
</main>
